/**
 * @generated SignedSource<<7a6c683ee917f6d77af753e5f2981cac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ecommerceTrackingProductData_item$data = {
  readonly address: {
    readonly englishCountryName: string | null;
  } | null;
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly contemporaryTrackingString: string;
  readonly displayPriceTracking: ReadonlyArray<{
    readonly amountType: string | null;
    readonly convertedAmountList: ReadonlyArray<{
      readonly amount: number | null;
      readonly currency: Currency | null;
    } | null> | null;
    readonly textType: string | null;
  } | null> | null;
  readonly isNewListing: boolean | null;
  readonly personalizationType: string | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"shippingCostHelpers_item">;
  readonly " $fragmentType": "ecommerceTrackingProductData_item";
};
export type ecommerceTrackingProductData_item$key = {
  readonly " $data"?: ecommerceTrackingProductData_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ecommerceTrackingProductData_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ecommerceTrackingProductData_item"
};

(node as any).hash = "59bc1f3111e50ea8f913f202d6c3870b";

export default node;
